/**
 * Онбординг: вторая аллергия на Free (отдельная вёрстка в UnifiedPaywall).
 */

import { paywallBodyPair } from "@/utils/paywallBodyLines";

export const ONBOARDING_SECOND_ALLERGY_PAYWALL_TITLE = "Важно учитывать всё питание ребёнка 💛";

export const ONBOARDING_SECOND_ALLERGY_PAYWALL_BODY_LINES = paywallBodyPair(
  "В бесплатной версии — одна аллергия",
  "В полной — всё питание ребёнка без риска",
);
